import React from 'react';

const TeamModal = ( props ) => (
  <div className="teampopop modal fade" id={props.id} tabIndex="-1" role="dialog" aria-labelledby="basicModal" aria-hidden="true">
    <div className="modal-dialog modal-dialog-zoom modal-md">
      <div className="modal-content">
        <div className="modal-body p-lg-5">
          <img src={props.img} alt=""/>
          <h4 className="display-4 font-weight-bold mt-3">{props.name}</h4>
          <h5 className="mb-4">{props.title}</h5>
          <a href={ `https://www.linkedin.com/in/${props.linkedin}` } className="social-circle" title="Linkedin" target="_blank" rel="noopener noreferrer">
            <i className="fab fa-linkedin-in" />
          </a>
          <hr className="my-5"/>
          <p>{props.description}</p>
        </div>
        <div className="modal-footer">
          <button type="button" className="btn btn-default" data-dismiss="modal">Close</button>
        </div>
      </div>
    </div>
  </div>
);

export default TeamModal;
